<template>
    <div
        v-if="isAppLoaded && canStart"
        :class="['p-mobile', 'mobile', { 'mobile--landscape': isLandscape }]"
        :style="uiColors"
    >
        <TMobile>
            <template #header>
                <AHeroTitle :text="$t('ui.mobile-hero-title')" />
                <OMHeader v-if="isHeader"/>
            </template>
            <template #main>
                <router-view />
            </template>
            <template #modal>
                <OBaseModal
                    v-if="modalOrganism"
                    :organism="modalOrganism.component"
                />
            </template>
        </TMobile>
    </div>
    <AInitialLoader v-else />
</template>

<script>
import '../../../assets/images/generated-svg';

import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex';

import * as Sentry from "@sentry/vue";

import TMobile from '../../templates/t-mobile/t-mobile';
import OMHeader from '../../organisms/o-m-header/o-m-header';
import AHeroTitle from '../../atoms/a-hero-title/a-hero-title';
import OBaseModal from '../../organisms/o-modal-base/o-modal-base';
import AInitialLoader from '../../atoms/a-initial-loader/a-initial-loader';

import canStart from '../../../utils/mixins/can-start';

import {
    TYPES,
    MOBILE_ROOT,
    MOBILE_GUIDE,
} from '@/utils/constants/pages';
import {APP_TYPES} from "@/utils/constants/app-constants";

export default {
    name: 'PMobile',
    mixins: [canStart],
    components: {
        TMobile,
        OMHeader,
        OBaseModal,
        AHeroTitle,
        AInitialLoader
    },
    data() {
        return {
            modalOrganism: null
        }
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape
        }),
        ...mapGetters([
            'isAppLoaded',
            'getMapConfigProp',
            'getDenormalisedObjectById'
        ]),
        isHeader() {
            return [MOBILE_ROOT, MOBILE_GUIDE].includes(this.$route.name)
                || [].includes(this.$route.name) && !this.isLandscape;
        },
        uiColors() {
            return this.getMapConfigProp('ui_colors') || null;
        }
    },
    created() {
        document.querySelector("meta[name=viewport]").setAttribute(
            'content', 
            'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
        );
        
        this.loadMapData();
        Sentry.setTag("app-type", APP_TYPES.MOBILE);

    },
    watch: {
        isAppLoaded: {
            handler(value) {
                if(value) {
                    this.checkOrientation();
                    this.changeLocaleAtStart();
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.setDynamicVh();
        this.initEventsListeners();
    },
    destroyed() {
        this.deactivateEventsListeners();
    },
    methods: {
        ...mapActions([
            'fetchMapData',
            'changeLocaleAtStart'
        ]),
        async loadMapData() {
            try {
                const mapId = Number(this.$route.params.mapId);
                await this.fetchMapData(mapId);
                if (this.$route.params.qrId) this.proceedQrCodeData();
            } catch(error) {
                console.log('Data fetch error', error);
            }
        },
        initEventsListeners() {
            window.addEventListener('resize', this.setDynamicVh);
            window.addEventListener("orientationchange", this.checkOrientation);
        },
        deactivateEventsListeners() {
            window.removeEventListener('resize', this.setDynamicVh);
            window.removeEventListener('orientationchange', this.checkOrientation); 
        },
        setDynamicVh() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            window.scroll(0, 0);
        },
        checkOrientation() {
            console.log('checking orientation');
            // Works for mobile safari & ios web view
            const landscape = window.orientation === 90 || window.orientation === -90;
            // const portrait = window.innerHeight > window.innerWidth;
            
            if (landscape) this.$store.commit('setLandscapeMode', true);
            else this.$store.commit('setLandscapeMode', false);          

            // if (isMobileSafari) landscapeSafari ? this.showRotateDeviceModal() : this.resetModal();
            // else if (isAndroid) portrait ? this.showRotateDeviceModal() : this.resetModal();
            // else this.checkNonSafari();
        },
        checkNonSafari() {
            const landscape = window.innerHeight < window.innerWidth;
            landscape ? this.showRotateDeviceModal() : this.resetModal();
        },
        resetModal() {
            this.modalOrganism = null;
            this.setDynamicVh();
        },
        showRotateDeviceModal() {
            this.modalOrganism = {
                component: 'rotateDevice'
            }
        },
        proceedQrCodeData() {
            try {
                const qrId = Number(this.$route.params.qrId);
                const qrObj = this.getDenormalisedObjectById(qrId);
                const start = qrObj.meta?.qr.start || '';
                const destination = qrObj.meta?.qr.destination || '';
                const noClosestEntrance = qrObj.meta?.qr.noClosestEntrance || '';
                const params = {
                    name: MOBILE_GUIDE,
                    params: {
                        type: TYPES.CARE,
                        qr: true
                    },
                    query: {
                        'redirect-from': 'qr'
                    }
                };

                if (!start && !destination) return;

                if (start && destination) {
                    params.query.from = start;
                    params.query.to = destination;
                } else if (start) {
                    params.query.from = start;
                } else if (destination && noClosestEntrance) {
                    params.query.to = destination;
                } else if (destination) {
                    params.query.to = destination;
                    params.params.closest = true;
                }

                this.$router.push(params);
            } catch (error) {
                console.warn('QR code is not valid');
            }
        }
    }
}
</script>

<style lang="scss" src="./p-mobile.scss" />
